exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".disable-text-area {\n  opacity: 0.7;\n  cursor: default;\n}\n.disable-text-area::-webkit-scrollbar-thumb:hover {\n  background: #070707;\n}\n.custom-query-text-area {\n  min-height: 150px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./src/styles/pages/utilities/customqueries/index.less
// module id = 3661
// module chunks = 0